// The NZBN API URL
const SEARCH_URL = '/api/nzbn_search?query=';
const CHECK_URL = '/api/nzbn_check?query=';
export default class NZBNController extends Classy {
  constructor() {
    super();
    this.searchURL = SEARCH_URL;
    this.checkURL = CHECK_URL;
    this.xhr = new XMLHttpRequest();

    // Register some custom events
    this['search:success'] = 1;
    this['search:error'] = 1;
    this['check:success'] = 1;
    this['check:error'] = 1;
  }
  post(url, query, event) {
    // Create the URL
    const requestURL = url + query;

    // Cancel any previous requests
    this.xhr.abort();

    // Create a new request
    this.xhr = new XMLHttpRequest();

    // Open the request
    this.xhr.open('POST', requestURL, true);

    // On load
    this.xhr.onload = () => {
      if (this.xhr.status >= 200 && this.xhr.status < 300) {
        this.success(this.xhr.responseText, event);
      } else {
        this.error(this.xhr.responseText, event);
      }
    };

    // On error
    this.xhr.onerror = () => {
      this.error(this.xhr.responseText, event);
    };

    // Send the request
    this.xhr.send();
    this.callback('post');
  }
  search(query) {
    // Post the request
    this.post(this.searchURL, query, 'search');
    // Trigger the search event
    this.callback('search');
  }
  check(value) {
    // Post the request
    this.post(this.checkURL, value, 'check');
    // Trigger the check event
    this.callback('check');
  }
  success(response, event) {
    // Send the data to the callback function
    this.callback(event + ':success', response);
  }
  error(response, event) {
    this.callback(event + ':error', response);
  }
  reset() {
    // reset the events object
    this.events = {};
  }
}